import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { ISaveOrthondonticReferralTreatment, IOrthodonticReferralTherapy, ISaveOrthodonticReferralICD10Code, IOrthodonticReferralICD10Code, IAddOrthodonticReferralTherapy } from "../models/IOrthodonticReferral";
import { IPatientTreatment } from "../models/IPatientTreatment";
import { objectToQueryString } from "../helpers/ApiHelper";

export class OrthodonticReferralTreatmentApi extends ApiClient {

    constructor(auth: AuthContextModel) {
        super(auth);
    }

    takeResposiblityForTreatment(orthodonticReferralId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralTreatment/takeResposiblityForTreatment/${orthodonticReferralId}`, undefined, success, error, final);
    }

    saveOrthodonticReferralOrthodonticCheckTreatment(treatment: ISaveOrthondonticReferralTreatment, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralTreatment/orthodonticReferralOrthodonticCheckTreatment`, treatment, success, error, final);
    }

    saveOrthodonticReferralInterceptiveCheckTreatment(treatment: ISaveOrthondonticReferralTreatment, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralTreatment/orthodonticReferralInterceptiveCheckTreatment`, treatment, success, error, final);
    }

    getAvailableTreatmentCodes(orthodonticReferalId: number, success: (data: IPatientTreatment[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralTreatment/availableTreatmentCodes/${orthodonticReferalId}`, success, error, final);
    }

    getTherapies(success: (data: IOrthodonticReferralTherapy[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralTreatment/therapies`, success, error, final);
    }

    saveOrthodonticReferralTherapy(data: IAddOrthodonticReferralTherapy, success: () => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(data);
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralTreatment/orthodonticReferralTherapy?${queryString}`, undefined, success, error, final);
    }

    removeOrthodonticReferralTreatment(patientTreatmentId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/orthodonticReferralTreatment/${patientTreatmentId}`, success, error, final);
    }

    creditTreatment(patientTreatmentId: number, success: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralTreatment/creditTreatment/${patientTreatmentId}`, undefined, success);
    }

    getICD10Codes(success: (data: IOrthodonticReferralICD10Code[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/orthodonticReferralTreatment/icd10Codes`, success, error, final);
    }

    addICD10CodeMapping(data: ISaveOrthodonticReferralICD10Code, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralTreatment/icd10CodeMapping`, data, success, error, final);
    }

    deleteICD10CodeMapping(orthodonticReferralICD10CodeMappingId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/orthodonticReferralTreatment/icd10CodeMapping/${orthodonticReferralICD10CodeMappingId}`, success, error, final);
    }
}